module.exports = __webpack_public_path__ + "img/payment.b17e2c03.png";